import { EventEmitter } from "@angular/core";

export class ProcessStatusService{
  processStatusEmitter = new EventEmitter<any>();

  public processStatus = {
    allProcessSelected: false,
    filters: {},
    processIds: [],
    statusToBeUpdatedTo: -1,
  }

  getProcessStatusData(){
    return this.processStatus;
  }
  
  add(fields){
    this.processStatus = {
      ...this.processStatus,
      ...fields,
    }
    this.processStatusEmitter.emit(this.processStatus);
  }
}


// WEBPACK FOOTER //
// ./src/services/process-status.service.ts